import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import RootState from '../interfaces/root.interface';
const initialState =  true


const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<any>) => {
      return action.payload;
    }
  }
});

export const getLoader = (state: RootState) => state;
export default loadingSlice;
